import * as model from './model';
import * as view from './view';

export default function (){
    window.JCDwsDetailHotel = function (arParams)
    {
        this.errorCode = 0;

        this.config = {
            showSliderCarousel: false,
        };
        this.showSliderCarousel = null;

        this.visual = {};

        if (typeof arParams === 'object')
        {
            this.fullRatings = [];
            this.fullInput = [];
            this.fullTextarea = [];
            this.resultSuccess = false;
            this.preloader = null;
            this.dataMsg = {};
            this.params = arParams;
            this.visual = arParams['VISUAL'];
            this.form = arParams['FORM'];
            this.userId = arParams['USER_ID'];
            this.authorized = arParams['AUTHORIZED'];
            this.formData = {
                hotelId: this.form.HOTEL.HOTEL_ID,
                hotelPropId: this.form.HOTEL.HOTEL_PROP_ID,
                totalRatingPropId: this.form.TOTAL_RATINGS,
            };

            this.config.showSliderCarousel = this.params.CONFIG.SHOW_SLIDER_CAROUSEL;
            this.config.ajaxFOlderUrl = this.params.CONFIG.AJAX_FOLDER_URL;
            this.config.preloaderUrl = this.params.CONFIG.PRELOADER_URL;
            this.config.countLeaveReviews = this.params.CONFIG.COUNT_LEAVE_REVIEWS;

            // this.initModel();

            // console.log(this.formData)
            // console.log(BX.message('SITE_ID'))
            // console.log(arParams)
        }

        if (this.errorCode === 0)
        {
            BX.ready(BX.delegate(this.dwsInit, this));
        } else {
            console.error(this.errorCode)
        }
    };

    window.JCDwsDetailHotel.prototype = {

        dwsInit: function ()
        {
            this.showSlid = BX(this.visual.SLID_ID);
            this.showSliderCarousel = BX(this.visual.SLIDER_CAROUSEL_ID);
            this.blocsNav = BX(this.visual.BLOCS_NAV_ID);
            // this.latestReviews = BX(this.visual.LATER_REVIEWS_ID);
            // this.leaveFeedback = BX(this.visual.LEAVE_FEEDBACK_ID);
            // this.leaveFeedbackBtn = BX(this.visual.LEAVE_FEEDBACK_BTN_ID);
            this.tabDescLocation = BX('tab_desc_location');
            this.tabConvenienceHotel = BX('tab_convenience_hotel');
            // this.tabLatestReviews = BX('tab_latest_reviews');

            if (!this.config.showSliderCarousel && !this.showSlid) this.errorCode = -10;
            if (!this.config.showSliderCarousel && !this.showSliderCarousel) this.errorCode = -11;
            if (!this.blocsNav) this.errorCode = -12;
            // if (!this.latestReviews) this.errorCode = -13;
            // if (!this.leaveFeedback) this.errorCode = -20;
            // if (!this.leaveFeedbackBtn) this.errorCode = -21;
            if (!this.tabDescLocation) this.errorCode = -25;
            if (!this.tabConvenienceHotel) this.errorCode = -30;
            // if (!this.tabLatestReviews) this.errorCode = -35;
            if (!this.form) this.errorCode = -40;
            if (!this.config.preloaderUrl) this.errorCode = -50;

            if (this.errorCode === 0)
            {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    view.initShowSlid(this);
                } else {
                    view.adaptationColHotelAmenities(this);
                }
                view.initSlideOwlCarousel(this);
                view.initBlocsNav(this);
                view.locationMapIncrease(this);

                model.fancyboxOpen();

                // this.initLatestReviews();
                // this.latestReviewsBtn();

                // this.leaveFeedbackResultHtml = view.leaveFeedbackResultHtml;
                // this.eventBtnFormVerification = model.eventBtnFormVerification;

                /*const latestFeedbackJs = this.leaveFeedbackBtn.querySelector('.latest_feedback_js');
                if (latestFeedbackJs) {
                    BX.bind(this.leaveFeedbackBtn, 'click', BX.proxy(model.getFormLeaveFeedback, this));
                }*/
            } else {
                console.error(this.errorCode)
            }
        },

        // Последние отзывы гостей (показать / скрыть)
        initLatestReviews: function ()
        {
            const lrItem = this.latestReviews.querySelectorAll('.lr_item a');

            lrItem.forEach((link) => {
                link.addEventListener('click', view.showLatestReviews )
            })
        },

        // Подгружаем новые отзывов на ajax
        latestReviewsBtn: function ()
        {
            this.setMoreReviewsResult = view.setMoreReviewsResult;
            const latestReviewsBtn = this.tabLatestReviews.querySelector('a.latest_reviews_btn');

            BX.bind(latestReviewsBtn, 'click', BX.proxy(model.getMoreReviewsAjax, this));
        },

    };
}